import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import App from './App';

// Global fetch interceptor to automatically attach JWT tokens
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  if (typeof resource === 'string' && resource.includes('/api/')) {
    const token = localStorage.getItem('token');
    if (token) {
      config = config || {};
      config.headers = {
        ...config.headers,
        'Authorization': `Bearer ${token}`
      };
    }
  }
  const response = await originalFetch(resource, config);
  
  if (response.status === 401) {
    try {
      const clone = response.clone();
      const data = await clone.json();
      if (data && data.message === 'Invalid or expired token.') {
        window.dispatchEvent(new Event('auth-expired'));
      }
    } catch (e) {
      // Ignore JSON parse errors on clone
    }
  }
  
  return response;
};

// Prevent "[object Object]" - convert object rejections to proper Error
window.addEventListener('unhandledrejection', (e) => {
  const err = e.reason;
  if (err && typeof err === 'object' && !(err instanceof Error)) {
    e.reason = new Error(err.message || JSON.stringify(err));
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
